import React, { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE, API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../hook/use-http";
import Filter from "./Filter";
import VehicleDetails from "./VehicleDetails";
import DashboardMain from "../DashboardMain/DashboardMain";
import "./DigitalInstrumentalCluster.css";
import WaterMark from "../DashboardMain/WaterMark";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import IndicatorLamp from "./IndicatorLamp";
import DefLevel from "./DefLevel";
import Speedometer from "./Speedometer";
import DistanceToEmpty from "./DistanceToEmpty";
import styles from './DigitalInstrumentalCluster.module.css'
import { BsSticky } from "react-icons/bs";
import TopBottomPerformingVehicles from "./TopBottomPerformingVehicles";
import FilterSecondPage from "./FilterSecondPage";
import TopKpiCards from "./TopKpiCards";
import VehicleOperations from "./VehicleOperations";
import DICPopup from "./DICPopup";
import { PolygonMap } from "./PolygonMap";
import VectorLayersMap from "./VectorLayersMap";
import RangePolygonDetails from "./RangePolygonDetails";

function RangePolygon() {
  const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [modalData, setModalData] = useState({ title: "", data: [] })

  const log_data = (data) => { };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "range_polygon",
        },
      },
      log_data
    );
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter({ ...data });
  }, []);

  // const singleVinSelected = (vin) => {
  //   let vin_num = vin.split(",");
  //   setGloablfilter((prevdata) => {
  //     return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 };
  //   });
  // };

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] };
    });
  };

  const [selectedViews, setSelectedViews] = useState(["polygon"]); // Default: Show polygon
  const [mapKey, setMapKey] = useState(0); // 🔄 Force re-render

  const jsonData = { "Battery_SOC": 100, "Charging_stations": [[77.7099843, 13.0042883], [77.7099843, 13.0042883], [77.769928, 12.864369], [77.5782995, 12.8539223], [77.610098, 13.0429549], [77.5785936, 13.0689187], [77.5799538, 12.9486077]], "Charging_stations_available": "yes", "Distance_to_nearest_charging_station_(km)": 6.73, "Distance_to_vertices_": [119675, 100776, 103009, 133040, 125455, 118513, 119777, 103980, 105948, 135953, 125527, 124187, 129437, 127882, 135447, 121000, 117545, 119675], "Distance_to_vertices_(m)": [119675, 100776, 103009, 133040, 125455, 118513, 119777, 103980, 105948, 135953, 125527, 124187, 129437, 127882, 135447, 121000, 117545, 119675], "Latitude": 13.0569168, "Longitude": 77.6440064, "Nearest_charging_station": [77.610098, 13.0429549], "Nearest_charging_station_address": "149 3rd C main, 6th cross 9th block Nagarbhavi 2nd stage", "Polygon_Area": 28962.4891, "RP_execution_time_(sec)": 89.906722, "RP_start_time": "2025-02-13 09:40:26.982635", "Vertices": [[12.2455387, 77.7382709], [12.2893437, 77.4321368], [12.3069491, 77.3115402], [12.7027803, 76.8180739], [12.8078421, 76.7538804], [13.5410821, 76.8429155], [13.8109651, 77.1268239], [13.8614494, 77.4769163], [13.8550023, 77.5317121], [13.7405478, 78.2147527], [13.6593658, 78.2749458], [13.4406758, 78.4187332], [13.0906927, 78.6083646], [12.9426257, 78.6050629], [12.7813621, 78.570493], [12.5384555, 78.3720886], [12.2602204, 78.0903782], [12.2455387, 77.7382709]], "edgesCount": 14533, "nodesCount": 7032 }

  const rangeData = {
    Battery_SOC: jsonData.Battery_SOC,
    Charging_stations_available: "Yes",
    Distance_to_nearest_charging_station: "6.73 km",
    Nearest_charging_station: jsonData.Nearest_charging_station,
    Nearest_charging_station_address: jsonData.Nearest_charging_station_address
  };

  const toggleView = (view) => {
    setSelectedViews((prevViews) =>
      prevViews.includes(view) ? prevViews.filter(v => v !== view) : [...prevViews, view]
    );
  };

  const resetViews = () => {
    setSelectedViews([]); // Clear selections
    setMapKey(prevKey => prevKey + 1); // 🔄 Force map refresh
  };

  const onreset = (data) => {
    setGloablfilter(data);
  };

  // const loggedInUser = useSelector(selectLoggedInUser);

  // const cards = [{ cNm: 'Total / Active Vehicles', cCnt: '4566/2500', imgNm: 'tot_act_v', apiEnd: '' },
  // { cNm: 'Total Vehicles with Fault', cCnt: '1800', imgNm: 'tot_veh_f', apiEnd: 'tot_veh_fault_count' },
  // { cNm: 'Vehicles with BMS Fault', cCnt: '500', imgNm: 'v_BMS_f', apiEnd: 'BMS_fault_count' },
  // { cNm: 'Vehicles with DCDC Fault', cCnt: '300', imgNm: 'v_DCDC_f', apiEnd: 'DCDC_fault_count' },
  // { cNm: 'Vehicles with MCU Fault', cCnt: '200', imgNm: 'v_MCU_f', apiEnd: 'MCU_fault_count' },
  // { cNm: 'Vehicles with OBC Fault', cCnt: '550', imgNm: 'v_OBC_f', apiEnd: 'OBC_fault_count' },
  // { cNm: 'Vehicles with BCS Fault', cCnt: '250', imgNm: 'v_BCS_f', apiEnd: 'BCS_fault_count' }]

  // const oneCard = [{ cNm: 'Driving', apiEnd: 'driving' }, { cNm: 'Idling', apiEnd: 'idling' }, { cNm: 'Charging', apiEnd: 'charging' }, { cNm: 'Offline', apiEnd: 'offline' }, { cNm: 'Data Pack Expired', apiEnd: 'data_pack_expired' }]

  // const tabTemp = [
  //   { Tabtitle: 'Top 20 Vehicles with Fault ECU', tabCol1: 'Vins', tabCol2: 'Count', apiEnd: 'faulty_ECU_vehicles' },
  //   { Tabtitle: '20 Vehicles with Lowest SOC', tabCol1: 'Vins', tabCol2: 'Value', apiEnd: 'lowest_SOC_vehicles' },
  //   { Tabtitle: '20 Vehicles with Highest Motor Temp', tabCol1: 'Vins', tabCol2: 'Temp', apiEnd: 'motor_temp_vehicles' },
  //   { Tabtitle: '20 Vehicles with Highest Battery Temp', tabCol1: 'Vins', tabCol2: 'Temp', apiEnd: 'battery_temp_vehicles' }
  // ]

  // const getModalData = (ele) => {
  //   fetchData(
  //     {
  //       url: API_URL_MAIN + `real_time_fault_code/${ele.apiEnd}_tableData`,
  //       body: { filterdata: gloablfilter },
  //     },
  //     (data) => {
  //       setModalData(prev => ({
  //         ...prev,
  //         title: ele?.cNm,
  //         data: data,
  //       }))
  //     }
  //   );
  // }

  // if (gloablfilter.pageSelected === 1) {
  //   return (
  //     <>
  //       <DashboardMain>
  //         <div className="new_drive_dashboardDIC pt-1">
  //           <Filter onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
  //           <div className="container-fluid pb-3">
  //             <div className="row row-cols-2 justify-content-between">
  //               {cards.map((ele, i) => (
  //                 <>
  //                   <div class={`col mb-3 ${(i != 0) ? `${styles.pl0Important} hand_geture` : ''}`} data-toggle={`${i > 0 ? "modal" : ""}`} data-target={`${i > 0 ? "#myModal" : ""}`} onClick={() => { if (i > 0) { getModalData(ele) } }}>
  //                     <TopKpiCards cardsData={ele} gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
  //                   </div>
  //                 </>
  //               ))
  //               }
  //             </div>

  //             <div className="row">
  //               <div className="mb-3">
  //                 <div className={`${styles.kipBoxes} d-flex flex-wrap col-12 p-0`}>
  //                   <div className={`ps-2 col-12 col-md ${styles.KPI_left_right_card} d-flex justify-content-center align-items-center`}>
  //                     <p className="m-0">
  //                       <span className="fs-6 font-weight-bold text-white">Vehicles</span>
  //                     </p>
  //                   </div>

  //                   {oneCard.map((ele, i) => (
  //                     <div key={i} className={`ps-2 col-12 col-md ${(i !== 4) ? styles.forBetweenBorder : ''} d-flex flex-column align-items-start`}>
  //                       <VehicleOperations oneCard={ele} gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
  //                     </div>
  //                   ))}

  //                   <div className={`ps-2 col-12 col-md ${styles.KPI_right_left_Card} d-flex justify-content-center align-items-center`}>
  //                     <p className="m-0">
  //                       <span className="fs-6 font-weight-bold text-white">Operations</span>
  //                     </p>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>

  //             <div className="row">
  //               <div className="mb-3">
  //                 <div className={`${styles.kipBoxes} d-flex justify-content-center align-items-center`}>
  //                   <h5 className={`text-start mt-2 ${styles.textColorGreen} ${styles.fw_600}`}>
  //                     Top/Bottom Performing Vehicles
  //                   </h5>
  //                 </div>
  //               </div>
  //             </div>

  //             <div className="row">
  //               {tabTemp.map((ele, i) => (
  //                 <div className={`col-md-3 ${(i !== 0) ? styles.pl0Important : ''}`}>
  //                   <TopBottomPerformingVehicles tableData={ele} gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
  //                 </div>
  //               ))}
  //             </div>
  //           </div>
  //         </div>
  //         <DICPopup data={modalData} singleVinSelected={singleVinSelected} />
  //       </DashboardMain>
  //     </>
  //   );
  // } else {
  return (
    <DashboardMain gloablfilter={gloablfilter}>
      <div className="new_drive_dashboardDIC">
        <FilterSecondPage onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} pageChange={pageChange} />
        {/* {(gloablfilter.VIN_NUM.length > 0) ? */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-12" >
              <div className="row mb-3 equal-cols">
                <div className="col-md-3 col-sm-12 col-lg-3 pr-1 borderDownDIC">
                  <WaterMark />
                  <VehicleDetails title="Vehicle Details" gloablfilter={gloablfilter} />
                </div>
                <div className="col-md-6 col-sm-12 col-lg-6 pr-1 borderDownDIC">
                  {/* <VectorLayersMap key={mapKey} jsonData={jsonData} selectedViews={selectedViews} /> */}
                  <VectorLayersMap key={mapKey} gloablfilter={gloablfilter} selectedViews={selectedViews} />
                </div>
                <div className="col-md-3 col-sm-12 col-lg-3 borderDownDIC">
                  <RangePolygonDetails
                    data={rangeData}
                    toggleView={toggleView}
                    selectedViews={selectedViews}
                    resetViews={resetViews}
                    gloablfilter={gloablfilter}
                  />
                </div>
                {/* <PolygonMap key={mapKey} jsonData={jsonData} selectedViews={selectedViews} /> */}
                {/* <div className="col-md-9 col-sm-12 col-lg-9 borderDownDIC">
                    <div className="row">
                      <div className="col-md-12 borderDownDIC">
                        <WaterMark />
                        <IndicatorLamp gloablfilter={gloablfilter} />
                      </div>
                    </div>
                    <div className="row equal-cols">
                      <div className="col-md-4 col-sm-12 col-lg-3 pr-1 borderDownDIC">
                        <WaterMark />
                        <DefLevel title="State of Charge" sign="%" gloablfilter={gloablfilter} />
                      </div>
                      <div className="col-md-4 col-sm-12 col-lg-6 pr-1 borderDownDIC">
                        <WaterMark />
                        <Speedometer title="Speedometer" gloablfilter={gloablfilter} />
                      </div>
                      <div className="col-md-4 col-sm-12 col-lg-3 borderDownDIC">
                        <WaterMark />
                        <DistanceToEmpty title="KM To Discharged" sign="KM" gloablfilter={gloablfilter} />
                      </div>
                    </div>
                  </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* : <h1>NO DATA FOUND</h1> */}
        {/* } */}
      </div>
    </DashboardMain>
  );
  // }
}

export default RangePolygon;